import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ProposalData } from 'ts/shared/interfaces/ProposalData';
import { addLogs } from 'services/user';
import { getProposalPreview } from 'services/proposal';
import withErrorBoundary from '../../withErrorBoundary';
import { I18nextProvider } from 'react-i18next';
import { EditProposalContext } from 'contexts/EditProposaContext';
import TripBuilderClient from './TripBuilderClient';
import { i18nProposal } from 'utils/shared/utils';
import { resolveLanguageFromProposal } from 'utils/shared/tripResultBuilderPreview';
import { isTripBuilderProposal } from 'utils/shared/tripBuilder';

const TripBuilderPage = () => {
  const [urlParams] = useSearchParams();
  const [proposal, setProposal] = useState<ProposalData>();
  const asTripBuilder = urlParams.get('tripBuilder') === 'true';

  useEffect(() => {
    const loadProposal = async () => {
      try {
        const res = await getProposalPreview(urlParams.get('id2') as string);

        if (res) {
          setProposal(res);

          if (res.externalParam_1) {
            const param = JSON.parse(res.externalParam_1);
            sessionStorage.setItem('tbStyle', param.tbStyle);
          }
        } else {
          addLogs(`proposal_preview_not_found ${urlParams.get('id')}`);
        }
      } catch (err) {
        console.error('Error loading proposal:', err);
        addLogs(`proposal_preview_error ${urlParams.get('id')} ${err}`);
      }
    };

    loadProposal();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlParams.get('id'), urlParams.get('id2')]);

  const providerValue = {
    editMode: false,
    onClickEdit: () => { },
    onClickDelete: () => { },
    onClickEditPrice: () => { },
    proposal: proposal,
  };

  if (proposal && isTripBuilderProposal(proposal, false, asTripBuilder)) {
    const language = resolveLanguageFromProposal(proposal.externalParam_1);

    return (
      <div
        className="pr-html pr-html-trip-builder"
        style={{ paddingBottom: 0 }}
        dir={language === 'he' ? 'rtl' : 'ltr'}
      >
        <EditProposalContext.Provider value={providerValue}>
          <I18nextProvider i18n={i18nProposal}>
            <TripBuilderClient proposal={proposal} onProposalUpdated={setProposal} />
          </I18nextProvider>
        </EditProposalContext.Provider>
      </div>
    );
  }

  return <div></div>;
};

export default withErrorBoundary(TripBuilderPage, 'TripBuilderPage');
